<template>
  <div class="leaflet-control-layers" :class="{ 'leaflet-control-layers-expanded': expanded }" @mouseenter="expanded = true" @mouseleave="expanded = false">
    <a class="leaflet-control-layers-toggle" href="#" title="Layers" role="button"></a>
    <section class="leaflet-control-layers-list">
      <div class="leaflet-control-layers-base">
        <label v-for="provider in tileProviders" :key="provider.name" class="layer-item">
          <span>
            <input
              type="radio"
              name="tile-provider"
              :checked="provider.visible"
              @change="switchTileProvider(provider.name)"
            >
          </span>
          <span class="layer-label">{{ provider.name }}</span>
        </label>
      </div>
      <div class="leaflet-control-layers-separator" style="display: none;"></div>
      <div class="leaflet-control-layers-overlays"></div>
    </section>
  </div>
</template>

<script>
import MapService from '@/services/MapService'

export default {
  name: 'TilesLayerControl',
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    tileProviders() {
      return MapService.tileProviders || []
    }
  },
  methods: {
    switchTileProvider(name) {
      MapService.switchTileProvider(name)
    }
  }
}
</script>